import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { INDUSTRIES } from "@/data/content";

export default function IndustriesSection() {
  return (
    <section data-testid="industries-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="eyebrow">/ 02 · Who we build for</div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tighter text-white">
              Industries we ship in <span className="text-gradient">production</span>.
            </h2>
          </div>
          <p className="text-slate-400 max-w-md text-[15px]">
            Deep playbooks for regulated and high-scale environments — not generic advice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={ind.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                className="glass rounded-2xl p-7 hover:border-violet-400/30 transition-all"
                data-testid={`industry-card-${ind.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-violet-500/20 to-cyan-500/20 border border-white/10">
                  <Icon size={22} className="text-violet-300" />
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold text-white">{ind.title}</h3>
                <p className="mt-3 text-slate-400 text-sm leading-relaxed">{ind.copy}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
